export const ORDER_DATETIME_FORMAT = 'YYYYMMDD hh:mm';
